import { faLock, faUser } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import CryptoJS from "crypto-js";
import PropTypes from "prop-types";
import React, { Fragment } from "react";
import { connect } from "react-redux";
import STSComponent from "../../components/STSComponent/STSComponent";
import { globals } from '../../globals';
import BookMark from "../../images/bookmark.png";
import StatescapeLogo from "../../images/statescape-logo.png";
import LoginIcon from "../../images/statescape-signon.png";
import { logIn } from "../../store/reducers/auth";
import "./css/Login.scss";

class LogInView extends STSComponent {
  constructor(props) {
    super(props);

    const localData = localStorage.getItem("logData");
    sessionStorage.removeItem("modalSinglePage");
    let newObj = {
      userName: "",
      userPassword: "",
    };
    if (localData) {
      const decrypted = CryptoJS.AES.decrypt(
        localData.toString(),
        "myAuthCookie"
      );
      newObj = JSON.parse(decrypted.toString(CryptoJS.enc.Utf8));
    }

    // window.localStorage.clear();
    this.urlSearch = window.location.search;

    this.state = {
      user: newObj.userName,
      pass: newObj.userPassword,
      countOfLogin: 0,
      isChecked: false,
      signInClicked: false,
    };

    this.handleUserChange = this.handleUserChange.bind(this);
    this.handlePassChange = this.handlePassChange.bind(this);
    this.onEnterPress = this.onEnterPress.bind(this);
    this.rememberMe = this.rememberMe.bind(this);
    this.signIn = this.signIn.bind(this);
    this.bookmarkPage = this.bookmarkPage.bind(this);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (!nextProps.successLogin && !nextProps.isLoggingIn) {
      this.setState({ countOfLogin: this.state.countOfLogin + 1 });
    }
    if (this.props !== nextProps) {
      if (nextProps.successLogin && !nextProps.isLoggingIn){
        this.props.history.push("/");
      }
    }       
  }

  handleUserChange = (event) => {
    this.setState({ user: event.target.value });
  };

  handlePassChange = (event) => {
    this.setState({ pass: event.target.value });
  };

  signIn = () => {
    const { user, pass } = this.state;
    const rememberMe = !!document.querySelector(".ch-remember").checked;
    event.preventDefault();
    this.props.logIn(user, pass, rememberMe);
    this.setState({ signInClicked: true });
  };

  bookmarkPage = () => {
    if (window.sidebar && window.sidebar.addPanel) {
      // Firefox <23
      window.sidebar.addPanel(document.title, window.location.href, "");
    } else if (window.external && "AddFavorite" in window.external) {
      // Internet Explorer
      window.external.AddFavorite(location.href, document.title);
    } else {
      window.alert("Please use CTRL + D to bookmark this page");
    }
  };

  onEnterPress = (event) => {
    if (event && event.which === 13) {
      this.signIn();
    }
  };

  rememberMe = () => {
    const rememberMe = document.querySelector(".ch-remember");
    if (rememberMe.checked) {
      this.setState({ isChecked: true });
    } else {
      return this.setState({ isChecked: false });
    }
  };

  componentDidMount() {
    if (this.urlSearch) {
      var searchParams = new URLSearchParams(this.urlSearch);    

      // report variables may be passed in from unathenticated users 
      // accessing the services website. 
      const pageId = searchParams.get("pageid");
      const report = searchParams.get("report");
      const rec = searchParams.get("rec");
      const uid = searchParams.get("uid");

      // the following search params would be used by a companion report. 
      const companionNumbers = searchParams.get("CompanionNumbers");
      const companionState = searchParams.get("CompanionState");
      const session = searchParams.get("Session");

      // check whether a specifc destination should be specified 
      // rather than allowing the user to be sent to the root. 
      //
      // if report, rec and pageId exist then getReport 
      // is the appropriate destination (in the services website.) 
      //
      // if companionNumbers, companionState and session are populated then redirect
      // to the companion report. 
      if(pageId && report && companionNumbers && companionState && session){
        // eslint-disable-next-line max-len
        // pageid=legis&report=companionbills&CompanionNumbers=SB1219&CompanionState=Minnesota&Session=2025-2026
        let url = `${globals.servicesUrl}/search/getreport.aspx?pageid=${pageId}&report=${report}&CompanionNumbers=${companionNumbers}&CompanionState=${companionState}&Session=${session}`
        localStorage.setItem('destination', JSON.stringify({ server: globals.servicesUrl, url }))
        console.log('destination localStorage set.');
      } else if(pageId && report && rec && uid){
        // eslint-disable-next-line max-len
        let url = `${globals.servicesUrl}/search/getreport.aspx?pageid=${pageId}&report=${report}&rec=${rec}&uid=${uid}`
        localStorage.setItem('destination', JSON.stringify({ server: globals.servicesUrl, url }))
        console.log('destination localStorage set.');
      } else if (pageId && report && rec){
        // eslint-disable-next-line max-len
        let url = `${globals.servicesUrl}/search/getreport.aspx?pageid=${pageId}&report=${report}&rec=${rec}`
        localStorage.setItem('destination', JSON.stringify({ server: globals.servicesUrl, url }))
        console.log('destination localStorage set.');
      }
     }
  }

  render() {
    const numberOfAttempts = this.state.countOfLogin;
    const { user, pass } = this.state;

    return (
      <Fragment>
        <header className="login-header">
          <a href="http://www.statescape.com/">
            <img src={StatescapeLogo} alt="logo" />
          </a>
        </header>
        <div className="login-body">
          <br />
          <div className="login-form-wrapper">
            <div className="login-form">
              <div className="login-icon-wrapper">
                <img src={LoginIcon} alt="sign in icon" />
              </div>
              <div className="login-inputs-wrapper">
                <h3 className="login-form-heading">Welcome back</h3>
                {numberOfAttempts < 3 ? (
                  <form onSubmit={this.signIn}>
                    {numberOfAttempts === 0 ? null : (
                      <p className="alert-danger" role="alert">
                        Sign in failed. Please try again. 
                      </p>
                    )}
                    <div className="inner-input">
                      <FontAwesomeIcon icon={faUser} />
                      <input
                        className="form-control"
                        type="user"
                        name="userName"
                        onChange={this.handleUserChange}
                        value={user}
                        placeholder="Username"
                        onKeyPress={this.onEnterPress}
                        autoComplete="userName"
                      />
                    </div>
                    <div className="inner-input">
                      <FontAwesomeIcon icon={faLock} />
                      <input
                        className="form-control"
                        type="password"
                        name="userPassword"
                        onChange={this.handlePassChange}
                        value={pass}
                        placeholder="Password"
                        onKeyPress={this.onEnterPress}
                        autoComplete="userPassword"
                      />
                    </div>
                    <div className="remember">
                      <input
                        className="ch-remember"
                        type="checkbox"
                        onClick={this.rememberMe}
                      />
                      Remember me
                    </div>
                    <button type="submit" className="btn btn-block login-btn">
                      Sign in
                    </button>
                    <div className="login-terms">By signing in you agree to our <a href="https://www.statescape.com/about/clienttermsofuse/">Terms of Use</a>.</div>
                    <div className="login-assistance"><a href="/forgotpw">Forgot password?</a> or <a href="/forgotun">Forgot username?</a></div>
                  </form>
                ) : (
                  <Fragment>
                  <div className="login-body failed-body">
                    <div>Login attempts failed!</div>
                    <div>Please contact</div>
                    <div>
                    <a style= {{ color: '#000000', textDecoration: 'underline' }}
                    href="mailto:support@statescape.com">support@statescape.com</a>
                    </div>
                    <div>for assistance</div>
                  </div>
                  <div className="login-assistance"><a href="/forgotpw">Forgot password?</a> or <a href="/forgotun">Forgot username?</a></div>
                  </Fragment>
                )}
              </div>
            </div>
            <div className="bookmark">
              <img src={BookMark} onClick={this.bookmarkPage} />
              <span onClick={this.bookmarkPage}>
                Bookmark this page for quick access.
              </span>
            </div>
          </div>
        </div>
        <footer>
          <div className="d-flex align-items-center h-100 justify-content-between">
            <div><nobr>&#xA9; StateScape {new Date().getFullYear()}</nobr> &nbsp;
            <span className="privacy-link">
            <a href="https://www.statescape.com/about/privacypolicy/">Privacy Policy</a>
            </span>
            </div>
            <div className="terms-link">
            <a href="https://www.statescape.com/about/clienttermsofuse/">Terms of Use</a>
            </div>
            <div className="support-link">
              <a href="mailto:customer.support.mail@statescape.com">
                support@statescape.com
              </a>
            </div>
          </div>
        </footer>
      </Fragment>
    );
  }

  static propTypes = {
    logIn: PropTypes.func,
    isLoggingIn: PropTypes.bool,
    successLogin: PropTypes.bool,
  };
}

const mapDispatchToProps = {
  logIn,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  isLoggingIn: state.auth.isLoggingIn,
  successLogin: state.auth.successLogin,
});

export default connect(mapStateToProps, mapDispatchToProps)(LogInView);



// WEBPACK FOOTER //
// ./src/routes/Login/Login.js